import { toast } from "react-toastify";
import { config, errToast } from "../../utils";
import { handleSiteLoader } from "./authAction";
import { axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import { buildQuery, getTotalPages } from "../../helpers";
import { handleLiveAuctionData } from "../slice/liveAuctionSlice";

export const fetchSessions = (payload) => {
    return async (dispatch, getState) => {
        // dispatch(handleSiteLoader(true));
        dispatch(handleLiveAuctionData({
            sessions: { loading: true }
        }));
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        const sessions = state.liveAuction.sessions;
        try {
            const response = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).get(
                buildQuery(
                    `/api-session/session-listing/`,
                    {
                        page: payload.page,
                        page_size: sessions.page_size,
                        status: sessions.status,
                    },
                ),
                config);
            if (response.status === 200 && response.data.error === 0) {
                console.info({ data: response.data.data })
                const {
                    data,
                    total
                } = response.data.data;
                dispatch(handleLiveAuctionData({
                    sessions: {
                        data,
                        page: payload.page,
                        totalPage: getTotalPages(total, sessions.page_size),
                        loading: false
                    }
                }))
                // dispatch(handleSiteLoader(false));
            } else toast.error(response.data.msg);
            // dispatch(handleSiteLoader(false));
            return response.data.data;
        } catch (err) {
            errToast(err);
            // dispatch(handleSiteLoader(false));
        }
    };
};


export const fetchLots = (payload) => {
    return async (dispatch, getState) => {
        // dispatch(handleSiteLoader(true));
        dispatch(handleLiveAuctionData({
            lots: { loading: true }
        }));
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        const lots = state.liveAuction.lots;
        try {
            const response = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).get(
                buildQuery(
                    `/api-session/lot-listing/${payload.session_id}/`,
                    {
                        // page: payload.page,
                        // page_size: lots.page_size,
                    },
                ),
                config);
            if (response.status === 200 && response.data.error === 0) {
                const {
                    data,
                    total
                } = response.data.data;
                dispatch(handleLiveAuctionData({
                    lots: {
                        data: data ?? [],
                        // page: payload.page,
                        // totalPage: getTotalPages(total, lots.page_size),
                        loading: false
                    }
                }))
                // dispatch(handleSiteLoader(false));
            } else toast.error(response.data.msg);
            // dispatch(handleSiteLoader(false));
            return response.data.data;
        } catch (err) {
            errToast(err);
            // dispatch(handleSiteLoader(false));
        }
    };
};

export const fetchLivekitToken = ({ session_id }) => {
    return async () => {
        try {
            const response = await axiosAuth.post(
                "/api-session/livekit-token/",
                {
                    session_id,
                    token_type: "browser",
                },
                config
            );
            return response.data;
        } catch (error) {
            errToast(error);
            return null;
        }
    };
};

export const fetchActivityFeed = ({ lot_id }) => {
    return async () => {
        try {
            const response = await axiosAuth.get(
                `api-session/lot-data/${lot_id}/`,
                config
            );
            return response.data;
        } catch (error) {
            errToast(error);
            return null;
        }
    };
};
